import {inject, Injectable} from "@angular/core";
import {Router, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {AuthService} from "@shared/api/auth.service";
import {RolesEnum} from "@shared/enum/roles.enum";

@Injectable({
    providedIn: "root"
})
export class ConsoleGuard {
    private auth = inject(AuthService);
    private router = inject(Router);


    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.checkCredentials();
    }

    checkCredentials(): boolean {
        if (this.auth.roles.includes(RolesEnum.AC_ADMIN)) return true;
        this.router.navigate([this.router.url]).then(() => console.error("Invalid Credentials"));
        return false;
    }

}
